import { ProductVariantInterface } from '@qlevr/shared/interfaces';

export function getFirstAvailableVariant(variants: ProductVariantInterface[]): ProductVariantInterface | null {
  return variants.find((variant) => variant.availableForSale && variant.inventoryQuantity > 0) || null;
}
